import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { RouteObject } from 'react-router-dom'

import Create from './components/Create'
import { DetailBusiness } from './components/Detail'
import List from './components/List'

const BusinessModule: RouteObject = {
    path: 'account/businesses',
    children: [
        {
            path: '',
            element: <List pageType="member" />,
        },
        {
            path: 'new',
            element: <Create />,
        },
        {
            path: ':businessID',
            element: <DetailBusiness />,
        },
    ],

    errorElement: <ErrorPage status={500} />,
}

const HRMBusinessModule: RouteObject = {
    path: '/businesses',
    children: [
        {
            path: '',
            element: <List pageType="hrm" />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export { BusinessModule, HRMBusinessModule }
